import { INDICATORS } from "@/lib/brand";
import useCountUp from "@/hooks/useCountUp";

const Counter = ({ value, suffix, label, index }) => {
  const [count, ref] = useCountUp(value, { duration: 1600 });
  return (
    <div
      ref={ref}
      data-testid={`indicator-${index}`}
      className="relative"
    >
      <div className="font-display text-6xl lg:text-7xl font-bold text-white tracking-tighter leading-none">
        {count.toLocaleString("pt-BR")}
        <span className="text-gold">{suffix}</span>
      </div>
      <div className="mt-4 text-white/60 text-base leading-relaxed max-w-[220px]">
        {label}
      </div>
    </div>
  );
};

export const Indicators = () => {
  return (
    <section
      id="indicadores"
      data-testid="indicators-section"
      className="relative py-24 lg:py-28 bg-navy overflow-hidden grain"
    >
      <div
        className="absolute -top-32 left-1/4 w-[500px] h-[500px] rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.5), transparent)" }}
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14 reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-gold" />
            <span className="tracking-eyebrow text-gold">Indicadores</span>
          </div>
          <h2
            className="font-display text-4xl lg:text-5xl font-bold text-white leading-[1.05] tracking-[-0.025em]"
            data-testid="indicators-title"
          >
            Números que sustentam
            <br />
            sua produção.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {INDICATORS.map((ind, i) => (
            <Counter key={ind.label} {...ind} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
